import store from "@/store";
const pairlist = {
  'BSC': [
    {
      name: 'BNB',
      symbol: 'BNB',
      address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      chainId: 56,
      decimals: 18,
      balance: '',
      logoURI: require('@/assets/tokenlogo/BNB.png'),
    },
    {
      "chainId": 56,
      "address": "0x55d398326f99059fF775485246999027B3197955",
      "name": "USDT",
      "symbol": "USDT",
      "decimals": 18,
      "logoURI": require('@/assets/img/logo/USDT.png')
    },


  ],
  "JuChain": [{
    name: 'JU',
    symbol: 'JU',
    address: '0xC66A2f3E9923D495211BFbB051680A8Da7DE5a16',
    chainId: 210000,
    decimals: 18,
    logoURI: require('@/assets/tokenlogo/JU.png'),
  }, {
    "chainId": 210000,
    "address": "0xc8e19C19479a866142B42fB390F2ea1Ff082E0D2",
    "name": "USDT",
    "symbol": "USDT",
    "decimals": 18,
    "logoURI": require('@/assets/img/logo/USDT.png')
  },]
};

export function getAllPair(curA, curB) {
  let lpPair = [];
  let base = pairlist[store.state.netWorkConfig.key];
  for (let i = 0; i < base.length; i++) {
    if (base[i].address != curA.address) {
      lpPair.push({ toCur: base[i], fromCur: curA });
    }

    if (base[i].address != curB.address) {
      lpPair.push({ toCur: curB, fromCur: base[i] });
    }

    lpPair.push({ toCur: curB, fromCur: curA });
  }
  return lpPair;
}
